import * as React from 'react';
import { getPadding, setRect, getRect } from '../views/common/utils';
import { BORDER_WIDTH } from '../constants';
/** @hidden */
export var useSlotExpand = function (slot, condition) {
    var expand = function () {
        if (!condition || !slot.current) {
            return;
        }
        var element = slot.current.element;
        var props = slot.current.props;
        if (!element) {
            return;
        }
        var highest = 0;
        var slotPadding = getPadding(element);
        props.items.forEach(function (item) {
            if (!item._ref.current) {
                return;
            }
            var height = getRect(item._ref.current.element).height;
            if (height && height > highest) {
                highest = height;
            }
        });
        setRect(element, { height: (((props.items ? props.items.length : 0) * (highest + BORDER_WIDTH)) - (slotPadding || 0)) }, true);
    };
    React.useEffect(expand, [slot, slot.current && slot.current.props, condition]);
};
//# sourceMappingURL=useSlotExpand.js.map